import { render, staticRenderFns } from "./AsideMenuEditor.vue?vue&type=template&id=e0c488da&"
import script from "./AsideMenuEditor.vue?vue&type=script&lang=js&"
export * from "./AsideMenuEditor.vue?vue&type=script&lang=js&"
import style0 from "./AsideMenuEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports